import { connect } from 'react-redux';
import { push, goBack } from 'connected-react-router';
import { getReferral, updateReferral, syncTreatments, resetSyncStatusMsg } from '../../../actions/entities';
import ReferralView from '../../../features/Referrals/ReferralView';
import { checkFeatureAccess } from '../../../utils/helpers';
import globals from '../../../globals/communityGlobals';

const mapStateToProps = ({ entities: { referrals, treatments }, global: { auth }, uiElements: { tables } }) => {
  const { isFetching, referral } = referrals.previewed;
  return {
    isFetching,
    referral,
    canAddTreatments: checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canAddTreatments),
    canEditReferrals: checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canEditReferrals),
    canEditTreatments: checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canEditTreatments),
    enableIntegrationMode: checkFeatureAccess(
      auth.featureAccessList,
      globals.applicationFeatureAccesses.enableIntegrationMode,
    ),
    referralTreatments: tables.referralTreatments,
    externalProviderType: auth.externalProviderType,
    isFetchingComplete: treatments.previewedImportedTreatments.isFetchingComplete,
    areTreatmentsFetching: treatments.previewedImportedTreatments.areTreatmentsFetching,
    messages: treatments.previewedImportedTreatments.messages,
    auth,
  };
};

const mapDispatchToProps = dispatch => ({
  goBack: () => dispatch(goBack()),
  navigate: url => dispatch(push(url)),
  getReferral: id => dispatch(getReferral(id)),
  updateReferral: referralData => dispatch(updateReferral(referralData)),
  syncTreatments: model => dispatch(syncTreatments(model)),
  resetSyncStatusMsg: () => dispatch(resetSyncStatusMsg()),
});

const ReferralViewPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReferralView);

export default ReferralViewPage;
